// Curated fallback images from design guidelines (used when Google doesn't return photos)
const FALLBACK_IMAGES = [
  "https://images.unsplash.com/photo-1768697358705-c1b60333da35?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NDh8MHwxfHNlYXJjaHwyfHxyZXN0YXVyYW50JTIwaW50ZXJpb3IlMjB3YXJtJTIwbGlnaHRpbmd8ZW58MHx8fHwxNzc5MzU5NTM3fDA&ixlib=rb-4.1.0&q=85&w=800",
  "https://images.pexels.com/photos/827528/pexels-photo-827528.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.unsplash.com/photo-1777716003985-68fed08d0c7e?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxODd8MHwxfHNlYXJjaHwzfHxkZWxpY2lvdXMlMjBtaWRkbGUlMjBlYXN0ZXJuJTIwZm9vZCUyMHBsYXRlfGVufDB8fHx8MTc3OTM1OTUzN3ww&ixlib=rb-4.1.0&q=85&w=800",
  "https://images.pexels.com/photos/14969612/pexels-photo-14969612.jpeg?auto=compress&cs=tinysrgb&w=800",
  "https://images.unsplash.com/photo-1735923342219-c9e7e478058c?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwzfHxkZWxpY2lvdXMlMjBhc2lhbiUyMGhhbGFsJTIwZm9vZHxlbnwwfHx8fDE3NzkzNTk1Mzd8MA&ixlib=rb-4.1.0&q=85&w=800",
  "https://images.unsplash.com/photo-1737354620464-79307fe60ce7?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMzV8MHwxfHNlYXJjaHwyfHxkZWxpY2lvdXMlMjBhc2lhbiUyMGhhbGFsJTIwZm9vZHxlbnwwfHx8fDE3NzkzNTk1Mzd8MA&ixlib=rb-4.1.0&q=85&w=800",
];

// Deterministic hash so each restaurant always gets the same fallback image
function hashStr(s) {
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) | 0;
  return Math.abs(h);
}

export function getRestaurantImage(restaurant) {
  if (restaurant.photos && restaurant.photos.length > 0 && restaurant.photos[0].url) {
    return restaurant.photos[0].url;
  }
  const idx = hashStr(restaurant.place_id || restaurant.name || "x") % FALLBACK_IMAGES.length;
  return FALLBACK_IMAGES[idx];
}
